<template>
  <div
    ref="scaleContainer"
    class="sd-scale-line"
    :id="'scale-label-' + type"
  ></div>
</template>

<script>
import { ScaleLine } from 'ol/control'
/**
 * @description 比例尺控件
 * @author GuoYun
 */
export default {
  name: 'SdScale',
  data() {
    return {
      map_: null,
      control_: null,
    }
  },
  props: {
    type: {
      type: String,
      default() {
        return 'default'
      },
    },
  },
  beforeDestroy() {
    this.removeControl()
  },
  methods: {
    setMap(map) {
      this.map_ = map
      this.addControl()
    },
    addControl() {
      this.removeControl()
      this.control_ = new ScaleLine({
        className: 'ol-scale-line',
        units: 'metric',
        target: this.$refs.scaleContainer,
      })

      this.map_.addControl(this.control_)
    },
    removeControl() {
      if (this.control_) {
        this.map_.removeControl(this.control_)
      }
    },
  },
}
</script>

<style scoped>
/*
  比例尺组件样式
  @component SdScale
*/
#scale-label-default {
  background: white;
  color: black;
}
.sd-scale-line {
  position: absolute;
  left: 5px;
  bottom: 5px;
  z-index: 10;
}
</style>
